<template>
  <div class="message-detail">
    <div class="title-box">
      <span class="title">MESSAGES</span>
    </div>
    <div class="lists">
      <message-detail-box-user :data="reservation"></message-detail-box-user>
    </div>
    <div class="input-comment">
      <div class="comment">
        <textarea v-model="comment"></textarea>
      </div>
      <div class="profile">
        <img v-imageLoading="message.userProfileImage" />
      </div>
      <div class="button">
        <base-button-type-1
          text="SEND MESSAGE"
          @click="submitMessage"
        ></base-button-type-1>
      </div>
    </div>
    <div class="detail">
      <div class="show-comment" v-for="(item, index) in details" :key="index">
        <div v-if="item.type == $store.getters.userInfo.type" class="container">
          <div class="comment-me">
            <div class="comment" v-html="convertComment(item.comment)"></div>
            <div class="info">
              Me,
              <span v-convert-time="item.createDate.seconds"></span>
            </div>
          </div>
          <div class="profile-me">
            <img v-imageLoading="message.userProfileImage" />
          </div>
        </div>
        <div v-else class="container">
          <div class="profile-you">
            <img v-imageLoading="message.photographerProfileImage" />
          </div>
          <div class="comment-you">
            <div class="info">
              {{ item.name }},
              <span v-convert-time="item.createDate.seconds"></span>
            </div>
            <div class="comment" v-html="convertComment(item.comment)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessage, insertComment } from '@/api/message'
import MessageDetailBoxUser from '@/components/common/MessageDetailBoxUser'
import { defaultStore } from '@/library/firebase'
import BaseButtonType1 from '@/components/common/form-elemnets/BaseButtonType1'
import mixCommon from '@/mixin/common'

export default {
  mixins: [mixCommon],
  name: 'message-detail',
  components: { BaseButtonType1, MessageDetailBoxUser },
  data() {
    return {
      message: {},
      details: [],
      comment: '',
      reservation: []
    }
  },
  created() {
    this.getMessage()
  },
  methods: {
    getMessage() {
      const serviceId = this.$route.params.serviceId
      // console.log('service id:', serviceId)
      getMessage(serviceId).then(res => {
        this.message = res
        res.refReservation.get().then(doc => {
          console.log('reservation info:', doc.data())
          this.reservation.push(doc.data())
          // console.log('message reservation:', this.reservation[0])
        })

        defaultStore
          .collection('messages')
          .doc(serviceId)
          .collection('detail')
          .orderBy('createDate', 'desc')
          .onSnapshot(snap => {
            this.details = []
            snap.forEach(v => {
              this.details.push(v.data())
            })
            // console.log(this.details)
          })
      })
    },
    submitMessage() {
      // (uid, serviceId, comment, name, type)
      insertComment(
        this.$store.getters.userInfo.uid,
        this.$route.params.serviceId,
        this.comment,
        this.$store.getters.userInfo.name,
        'user'
      ).then(() => {
        // console.log('submit message response:', res)
        this.comment = ''
      })
    },
    convertComment(input) {
      // console.log('convertComment:', input)
      return input.replace(/(?:\r\n|\r|\n)/g, '<br>')
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
.message-detail {
  .title-box {
    width: 1080px;
    height: 60px;
    background-color: #ffffff;
    border-left: solid 1px #e7e7e7;
    border-top: solid 1px #e7e7e7;
    border-right: solid 1px #e7e7e7;
    text-align: center;
    .title {
      line-height: 60px;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 1px;
      text-align: center;
      color: #ab08b6;
    }
  }

  .lists {
    margin: 30px 0 0 0;
    .message-box {
      margin-bottom: 20px;
    }
  }

  .input-comment {
    margin: 20px 0 0 0;
    /*border: 1px dashed green;*/
    min-height: 172px;
    position: relative;

    .profile {
      width: 110px;
      height: 110px;
      position: absolute;
      right: 0;
      img {
        width: inherit;
        height: inherit;
        object-fit: cover;
      }
    }

    .button {
      width: 740px;
      height: 71px;
      background-color: #f5f5f5;
      border: 1px solid #f5f5f5;
      position: absolute;
      bottom: 0;
      left: 170px;
      .base-button-type-1 {
        position: absolute;
        right: 20px;
        bottom: 10px;
      }
    }

    .comment {
      border-radius: 0;
      position: absolute;
      height: 100px;
      width: 740px;
      left: 170px;
      //box-shadow: 0px 9px 76px -10px rgba(0, 0, 0, 0.51);
      border: 1px solid #e7e7e7;

      &::before {
        background-color: #fff;
        display: block;
        position: absolute;
        top: -7px;
        right: -10px;
        width: 50px;
        height: 50px;
        content: '';
        border-left: 1px solid #e7e7e7;
        border-top: 1px solid #e7e7e7;
        /*border: 1px solid #e7e7e7;*/
        transform: rotate(130deg) skewX(40deg);
        z-index: 1;
      }

      &::after {
        background-color: #fff;
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        top: 0;
        right: 0;
        margin: auto;
        border-radius: inherit;
        width: inherit;
        height: inherit;
        content: '';
        z-index: -1;
      }

      textarea {
        margin: 5px 0 0 5px;
        border: 0;
        width: 730px;
        height: 80px;
        z-index: 10;
        resize: none;
        outline: none;
      }
    }
  }

  .detail {
    display: flex;
    flex-direction: column;
    .show-comment {
      margin: 20px 0;
      width: 100%;
      height: auto;
      min-height: 110px;
      position: relative;

      .comment {
        margin: 0 0 20px 5px;
        font-family: Poppins;
        font-size: 16px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
      }

      .container {
        display: flex;
        justify-content: space-between;
        .profile-me {
          width: 110px;
          height: 110px;
          img {
            width: inherit;
            height: inherit;
            object-fit: cover;
          }
        }
        .profile-you {
          width: 110px;
          height: 110px;
          img {
            width: inherit;
            height: inherit;
            object-fit: cover;
          }
        }

        .comment-me {
          padding: 20px;
          border-radius: 0;
          position: relative;
          min-height: 70px;
          height: auto;
          width: 700px;
          margin-left: 170px;
          //box-shadow: 0px 9px 76px -10px rgba(0, 0, 0, 0.51);
          border: 1px solid #e7e7e7;

          .info {
            position: absolute;
            bottom: 19px;
            left: 25px;
          }

          &::before {
            background-color: #fff;
            display: block;
            position: absolute;
            top: -7px;
            right: -10px;
            width: 50px;
            height: 50px;
            content: '';
            border-left: 1px solid #e7e7e7;
            border-top: 1px solid #e7e7e7;
            /*border: 1px solid #e7e7e7;*/
            transform: rotate(130deg) skewX(40deg);
            z-index: 1;
          }

          &::after {
            background-color: #fff;
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
            top: 0;
            right: 0;
            margin: auto;
            border-radius: inherit;
            width: inherit;
            height: inherit;
            content: '';
            z-index: -1;
          }
        }
        .comment-you {
          margin-right: 170px;
          padding: 20px;
          border-radius: 0;
          position: relative;
          min-height: 70px;
          height: auto;
          width: 700px;
          //box-shadow: 0px 9px 76px -10px rgba(0, 0, 0, 0.51);
          border: 1px solid #e7e7e7;

          .info {
            position: absolute;
            bottom: 19px;
            left: 25px;
            z-index: 20;
          }

          &::before {
            background-color: #f5f5f5;
            display: block;
            position: absolute;
            top: -1px;
            left: -10px;
            width: 50px;
            height: 50px;
            content: '';
            border-left: 1px solid #e7e7e7;
            border-top: 1px solid #e7e7e7;
            /*border: 1px solid #e7e7e7;*/
            transform: rotate(0deg) skewX(40deg);
            z-index: 1;
          }

          &::after {
            width: 740px;
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
            top: 0;
            right: 0;
            margin: auto;
            border-radius: inherit;
            height: inherit;
            content: '';
            background-color: #f5f5f5;
            z-index: 2;
          }

          .comment {
            position: relative;
            z-index: 10;
            min-height: 70px;
          }
        }
      }
    }
  }
}
</style>
